import { render, staticRenderFns } from "./Resita.vue?vue&type=template&id=7953fbc4&"
import script from "./Resita.vue?vue&type=script&lang=js&"
export * from "./Resita.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports